import * as z from "zod/v4";

export const markAsPickedUp = {
  name: "markAsPickedUp" as const,
  input: z
    .object({ fulfillmentGroupIds: z.array(z.string()) })
    .or(z.object({ batchId: z.string() })),
  output: z.object({}),
};
